import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface ProgressbarProps {
  value?: number;
  showValue?: boolean;
  style?: any;
  styleClass?: string;
  unit?: string;
  mode?: 'determinate' | 'fakeMode' | 'reactMode';
  timeoutInMS?: number;
  totalTasks?: number;
}

export interface Progressbarhandler {
  updateValue: (number: number) => void;
  completOneTask: () => void;
}

export interface ProgressbarValue
  extends Omit<ProgressbarProps, 'value' | 'timeout'>,
  Progressbarhandler {
  value$: Observable<number>;
  completed$: Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class AdProgressbarService {
  useProgressBar(param: ProgressbarProps): ProgressbarValue {
    return progressbar(param);
  }
}

function progressbar({
  value: initialValue = 0,
  showValue = true,
  style,
  styleClass,
  unit = '%',
  mode,
  timeoutInMS = 3000,
  totalTasks,
}: ProgressbarProps) {
  let completedCount = 0;
  let completedStep = 0;
  const valueSubject = new BehaviorSubject<number>(initialValue);
  const completedSubject = new BehaviorSubject<boolean>(false);
  const value$ = valueSubject.asObservable();
  const completed$ = completedSubject.asObservable();

  const complete = () => {
    clearInterval(interval);
    completedSubject.next(true);
  };

  const updateValue = (val: number) => {
    valueSubject.next(val);
    if (val >= 100) {
      complete();
    }
  };
  const calculateMaxValue = () => {
    if (mode === 'fakeMode') {
      return 99;
    } else {
      let ceil = Math.ceil(((completedStep + 1) / totalTasks) * 100);
      if (ceil >= 100) {
        ceil = 99;
      }
      return ceil;
    }
  };
  const completOneTask = () => {
    if (mode === 'reactMode' && totalTasks > 0) {
      completedStep++;
      if (completedStep >= totalTasks) {
        complete();
      }
    }
  };

  if (mode === undefined || mode === null) {
    mode = totalTasks > 0 ? 'reactMode' : 'fakeMode';
  }

  let step = timeoutInMS / 100;
  let interval = setInterval(() => {
    let ceilValue = calculateMaxValue();
    if (completedCount >= ceilValue) {
      if (ceilValue == 100 || completedCount >= 100) {
        clearInterval(interval);
        completedSubject.next(true);
      }
    } else {
      completedCount++;
      valueSubject.next(completedCount);
    }
  }, step);

  if (mode === 'reactMode' && (Number.isNaN(totalTasks) || totalTasks <= 0)) {
    console.error(
      'Error!!! totalTasks must be set as an positive number in reactMode'
    );
    totalTasks = 1;
  }
  styleClass = `${styleClass || ''} ad-progressbar`;
  return {
    value$,
    completed$,
    showValue,
    style,
    styleClass,
    unit,
    mode,
    updateValue,
    completOneTask,
  };
}

export function useProgressBar({
  value: initialValue = 0,
  showValue = true,
  style,
  styleClass,
  unit = '%',
  mode,
  timeoutInMS = 3000,
  totalTasks,
}: ProgressbarProps) {
  let completedCount = 0;
  let completedStep = 0;
  const valueSubject = new BehaviorSubject<number>(initialValue);
  const completedSubject = new BehaviorSubject<boolean>(false);
  const value$ = valueSubject.asObservable();
  const completed$ = completedSubject.asObservable();

  const complete = () => {
    clearInterval(interval);
    completedSubject.next(true);
  };

  const updateValue = (val: number) => {
    valueSubject.next(val);
    if (val >= 100) {
      complete();
    }
  };
  const calculateMaxValue = () => {
    if (mode === 'fakeMode') {
      return 99;
    } else {
      let ceil = Math.ceil(((completedStep + 1) / totalTasks) * 100);
      if (ceil >= 100) {
        ceil = 99;
      }
      return ceil;
    }
  };
  const completOneTask = () => {
    if (mode === 'reactMode' && totalTasks > 0) {
      completedStep++;
      if (completedStep >= totalTasks) {
        complete();
      }
    }
  };

  if (mode === undefined || mode === null) {
    mode = totalTasks > 0 ? 'reactMode' : 'fakeMode';
  }

  let step = timeoutInMS / 100;
  let interval = setInterval(() => {
    let ceilValue = calculateMaxValue();
    if (completedCount >= ceilValue) {
      if (ceilValue == 100 || completedCount >= 100) {
        clearInterval(interval);
        completedSubject.next(true);
      }
    } else {
      completedCount++;
      valueSubject.next(completedCount);
    }
  }, step);

  if (mode === 'reactMode' && (Number.isNaN(totalTasks) || totalTasks <= 0)) {
    console.error(
      'Error!!! totalTasks must be set as an positive number in reactMode'
    );
    totalTasks = 1;
  }
  styleClass = `${styleClass || ''} ad-progressbar`;
  return {
    value$,
    completed$,
    showValue,
    style,
    styleClass,
    unit,
    mode,
    updateValue,
    completOneTask,
  };
}
